export const Inputs = [

    {
      id: "customerName",
      type: "text",
      placeholder: "Name",
      className:'Name'
      
    },
    {
      id: "company",
      type: "text",
      placeholder: "Company",
      className:'Company'
      
    },
    
    {
        id: "review",
        type: "text",
        placeholder: "review",
        className:'Review'
      
      },   
];